import { Component, Output, EventEmitter, OnInit, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-teb-ekonomik-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';
import { TebEkonomikService } from '../ctl-teb-ekonomik.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {DlistDto} from "@dabnet-kamu/libs/ui";
@Component({
  selector: 'dk-ctl-teb-ekonomik-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-teb-ekonomik-arama.component.html',
  styleUrls: ['./ctl-teb-ekonomik-arama.component.scss'],
})
export class CtlTebEkonomikAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private tebEkonomikService:TebEkonomikService,
    public ortakService:OrtakService
  ) {
    this.data = this.service.getData();
  }

  ngOnInit(): void {
    this.gridControlsList$ = this.tebEkonomikService.gridControlsList$;
    this.tebEkonomikService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}
